/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 *
 * Main lit-html module.
 *
 * Main exports:
 *
 * -  [[html]]
 * -  [[svg]]
 * -  [[render]]
 *
 * @packageDocumentation
 */ /**
 * Do not remove this comment; it keeps typedoc from misplacing the module
 * docs.
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ const $3e8bd64d8ced9af7$var$directives = new WeakMap();
const $3e8bd64d8ced9af7$export$99b43ad1ed32e735 = (f)=>(...args)=>{
        const d = f(...args);
        $3e8bd64d8ced9af7$var$directives.set(d, true);
        return d;
    };
const $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5 = (o)=>{
    return typeof o === "function" && $3e8bd64d8ced9af7$var$directives.has(o);
};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * True if the custom elements polyfill is in use.
 */ const $739d7429d0e9ac82$export$52a61c3a7415f2b1 = typeof window !== "undefined" && window.customElements != null && window.customElements.polyfillWrapFlushCallback !== undefined;
const $739d7429d0e9ac82$export$4cae3494608af418 = (container, start, end = null, before = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.insertBefore(start, before);
        start = n;
    }
};
const $739d7429d0e9ac82$export$77f49a256021c8de = (container, start, end = null)=>{
    while(start !== end){
        const n = start.nextSibling;
        container.removeChild(start);
        start = n;
    }
};


/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * A sentinel value that signals that a value was handled by a directive and
 * should not be written to the DOM.
 */ const $416fcdb557dd27f4$export$9c068ae9cc5db4e8 = {};
const $416fcdb557dd27f4$export$45b790e32b2810ee = {};


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * An expression marker with embedded unique key to avoid collision with
 * possible text in templates.
 */ const $c42ca2d32292a526$export$ffc4d0086f1a4c9 = `{{lit-${String(Math.random()).slice(2)}}}`;
const $c42ca2d32292a526$export$36b8314a2f34ed60 = `<!--${$c42ca2d32292a526$export$ffc4d0086f1a4c9}-->`;
const $c42ca2d32292a526$export$8c751b9db6965af4 = new RegExp(`${$c42ca2d32292a526$export$ffc4d0086f1a4c9}|${$c42ca2d32292a526$export$36b8314a2f34ed60}`);
const $c42ca2d32292a526$export$552ff45b274cc170 = "$lit$";
class $c42ca2d32292a526$export$14416b8d99d47caa {
    constructor(result, element){
        this.parts = [];
        this.element = element;
        const nodesToRemove = [];
        const stack = [];
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(element.content, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        // Keeps track of the last index associated with a part. We try to delete
        // unnecessary nodes, but we never want to associate two different parts
        // to the same index. They must have a constant node between.
        let lastPartIndex = 0;
        let index = -1;
        let partIndex = 0;
        const { strings: strings, values: { length: length } } = result;
        while(partIndex < length){
            const node = walker.nextNode();
            if (node === null) {
                // We've exhausted the content inside a nested template element.
                // Because we still have parts (the outer for-loop), we know:
                // - There is a template in the stack
                // - The walker will find a nextNode outside the template
                walker.currentNode = stack.pop();
                continue;
            }
            index++;
            if (node.nodeType === 1 /* Node.ELEMENT_NODE */ ) {
                if (node.hasAttributes()) {
                    const attributes = node.attributes;
                    const { length: length } = attributes;
                    // Per
                    // https://developer.mozilla.org/en-US/docs/Web/API/NamedNodeMap,
                    // attributes are not guaranteed to be returned in document order.
                    // In particular, Edge/IE can return them out of order, so we cannot
                    // assume a correspondence between part index and attribute index.
                    let count = 0;
                    for(let i = 0; i < length; i++)if ($c42ca2d32292a526$var$endsWith(attributes[i].name, $c42ca2d32292a526$export$552ff45b274cc170)) count++;
                    while(count-- > 0){
                        // Get the template literal section leading up to the first
                        // expression in this attribute
                        const stringForPart = strings[partIndex];
                        // Find the attribute name
                        const name = $c42ca2d32292a526$export$a5d53adfffe6a300.exec(stringForPart)[2];
                        // Find the corresponding attribute
                        // All bound attributes have had a suffix added in
                        // TemplateResult#getHTML to opt out of special attribute
                        // handling. To look up the attribute value we also need to add
                        // the suffix.
                        const attributeLookupName = name.toLowerCase() + $c42ca2d32292a526$export$552ff45b274cc170;
                        const attributeValue = node.getAttribute(attributeLookupName);
                        node.removeAttribute(attributeLookupName);
                        const statics = attributeValue.split($c42ca2d32292a526$export$8c751b9db6965af4);
                        this.parts.push({
                            type: "attribute",
                            index: index,
                            name: name,
                            strings: statics
                        });
                        partIndex += statics.length - 1;
                    }
                }
                if (node.tagName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
            } else if (node.nodeType === 3 /* Node.TEXT_NODE */ ) {
                const data = node.data;
                if (data.indexOf($c42ca2d32292a526$export$ffc4d0086f1a4c9) >= 0) {
                    const parent = node.parentNode;
                    const strings = data.split($c42ca2d32292a526$export$8c751b9db6965af4);
                    const lastIndex = strings.length - 1;
                    // Generate a new text node for each literal section
                    // These nodes are also used as the markers for node parts
                    for(let i = 0; i < lastIndex; i++){
                        let insert;
                        let s = strings[i];
                        if (s === "") insert = $c42ca2d32292a526$export$46b32044f78fe9b1();
                        else {
                            const match = $c42ca2d32292a526$export$a5d53adfffe6a300.exec(s);
                            if (match !== null && $c42ca2d32292a526$var$endsWith(match[2], $c42ca2d32292a526$export$552ff45b274cc170)) s = s.slice(0, match.index) + match[1] + match[2].slice(0, -$c42ca2d32292a526$export$552ff45b274cc170.length) + match[3];
                            insert = document.createTextNode(s);
                        }
                        parent.insertBefore(insert, node);
                        this.parts.push({
                            type: "node",
                            index: ++index
                        });
                    }
                    // If there's no text, we must insert a comment to mark our place.
                    // Else, we can trust it will stick around after cloning.
                    if (strings[lastIndex] === "") {
                        parent.insertBefore($c42ca2d32292a526$export$46b32044f78fe9b1(), node);
                        nodesToRemove.push(node);
                    } else node.data = strings[lastIndex];
                    // We have a part for each match found
                    partIndex += lastIndex;
                }
            } else if (node.nodeType === 8 /* Node.COMMENT_NODE */ ) {
                if (node.data === $c42ca2d32292a526$export$ffc4d0086f1a4c9) {
                    const parent = node.parentNode;
                    // Add a new marker node to be the startNode of the Part if any of
                    // the following are true:
                    //  * We don't have a previousSibling
                    //  * The previousSibling is already the start of a previous part
                    if (node.previousSibling === null || index === lastPartIndex) {
                        index++;
                        parent.insertBefore($c42ca2d32292a526$export$46b32044f78fe9b1(), node);
                    }
                    lastPartIndex = index;
                    this.parts.push({
                        type: "node",
                        index: index
                    });
                    // If we don't have a nextSibling, keep this node so we have an end.
                    // Else, we can remove it to save future costs.
                    if (node.nextSibling === null) node.data = "";
                    else {
                        nodesToRemove.push(node);
                        index--;
                    }
                    partIndex++;
                } else {
                    let i = -1;
                    while((i = node.data.indexOf($c42ca2d32292a526$export$ffc4d0086f1a4c9, i + 1)) !== -1){
                        // Comment node has a binding marker inside, make an inactive part
                        // The binding won't work, but subsequent bindings will
                        // TODO (justinfagnani): consider whether it's even worth it to
                        // make bindings in comments work
                        this.parts.push({
                            type: "node",
                            index: -1
                        });
                        partIndex++;
                    }
                }
            }
        }
        // Remove text binding nodes after the walk to not disturb the TreeWalker
        for (const n of nodesToRemove)n.parentNode.removeChild(n);
    }
}
const $c42ca2d32292a526$var$endsWith = (str, suffix)=>{
    const index = str.length - suffix.length;
    return index >= 0 && str.slice(index) === suffix;
};
const $c42ca2d32292a526$export$93919229d19012c8 = (part)=>part.index !== -1;
const $c42ca2d32292a526$export$46b32044f78fe9b1 = ()=>document.createComment("");
const $c42ca2d32292a526$export$a5d53adfffe6a300 = // eslint-disable-next-line no-control-regex
/([ \x09\x0a\x0c\x0d])([^\0-\x1F\x7F-\x9F "'>=/]+)([ \x09\x0a\x0c\x0d]*=[ \x09\x0a\x0c\x0d]*(?:[^ \x09\x0a\x0c\x0d"'`<>=]*|"[^"]*|'[^']*))$/;


class $5900699a09154d62$export$6eecef7813f38266 {
    constructor(template, processor, options){
        this.__parts = [];
        this.template = template;
        this.processor = processor;
        this.options = options;
    }
    update(values) {
        let i = 0;
        for (const part of this.__parts){
            if (part !== undefined) part.setValue(values[i]);
            i++;
        }
        for (const part of this.__parts)if (part !== undefined) part.commit();
    }
    _clone() {
        // There are a number of steps in the lifecycle of a template instance's
        // DOM fragment:
        //  1. Clone - create the instance fragment
        //  2. Adopt - adopt into the main document
        //  3. Process - find part markers and create parts
        //  4. Upgrade - upgrade custom elements
        //  5. Update - set node, attribute, property, etc., values
        //  6. Connect - connect to the document. Optional and outside of this
        //     method.
        //
        // We have a few constraints on the ordering of these steps:
        //  * We need to upgrade before updating, so that property values will pass
        //    through any property setters.
        //  * We would like to process before upgrading so that we're sure that the
        //    cloned fragment is inert and not disturbed by self-modifying DOM.
        //  * We want custom elements to upgrade even in disconnected fragments.
        //
        // Given these constraints, with full custom elements support we would
        // prefer the order: Clone, Process, Adopt, Upgrade, Update, Connect
        //
        // But Safari does not implement CustomElementRegistry#upgrade, so we
        // can not implement that order and still have upgrade-before-update and
        // upgrade disconnected fragments. So we instead sacrifice the
        // process-before-upgrade constraint, since in Custom Elements v1 elements
        // must not modify their light DOM in the constructor. We still have issues
        // when co-existing with CEv0 elements like Polymer 1, and with polyfills
        // that don't strictly adhere to the no-modification rule because shadow
        // DOM, which may be created in the constructor, is emulated by being placed
        // in the light DOM.
        //
        // The resulting order is on native is: Clone, Adopt, Upgrade, Process,
        // Update, Connect. document.importNode() performs Clone, Adopt, and Upgrade
        // in one step.
        //
        // The Custom Elements v1 polyfill supports upgrade(), so the order when
        // polyfilled is the more ideal: Clone, Process, Adopt, Upgrade, Update,
        // Connect.
        const fragment = (0, $739d7429d0e9ac82$export$52a61c3a7415f2b1) ? this.template.element.content.cloneNode(true) : document.importNode(this.template.element.content, true);
        const stack = [];
        const parts = this.template.parts;
        // Edge needs all 4 parameters present; IE11 needs 3rd parameter to be null
        const walker = document.createTreeWalker(fragment, 133 /* NodeFilter.SHOW_{ELEMENT|COMMENT|TEXT} */ , null, false);
        let partIndex = 0;
        let nodeIndex = 0;
        let part;
        let node = walker.nextNode();
        // Loop through all the nodes and parts of a template
        while(partIndex < parts.length){
            part = parts[partIndex];
            if (!(0, $c42ca2d32292a526$export$93919229d19012c8)(part)) {
                this.__parts.push(undefined);
                partIndex++;
                continue;
            }
            // Progress the tree walker until we find our next part's node.
            // Note that multiple parts may share the same node (attribute parts
            // on a single element), so this loop may not run at all.
            while(nodeIndex < part.index){
                nodeIndex++;
                if (node.nodeName === "TEMPLATE") {
                    stack.push(node);
                    walker.currentNode = node.content;
                }
                if ((node = walker.nextNode()) === null) {
                    // We've exhausted the content inside a nested template element.
                    // Because we still have parts (the outer for-loop), we know:
                    // - There is a template in the stack
                    // - The walker will find a nextNode outside the template
                    walker.currentNode = stack.pop();
                    node = walker.nextNode();
                }
            }
            // We've arrived at our part's node.
            if (part.type === "node") {
                const part = this.processor.handleTextExpression(this.options);
                part.insertAfterNode(node.previousSibling);
                this.__parts.push(part);
            } else this.__parts.push(...this.processor.handleAttributeExpressions(node, part.name, part.strings, this.options));
            partIndex++;
        }
        if (0, $739d7429d0e9ac82$export$52a61c3a7415f2b1) {
            document.adoptNode(fragment);
            customElements.upgrade(fragment);
        }
        return fragment;
    }
}


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ /**
 * @module lit-html
 */ 

/**
 * Our TrustedTypePolicy for HTML which is declared using the html template
 * tag function.
 *
 * That HTML is a developer-authored constant, and is parsed with innerHTML
 * before any untrusted expressions have been mixed in. Therefor it is
 * considered safe by construction.
 */ const $b0ba4ea5b56b9ecc$var$policy = window.trustedTypes && trustedTypes.createPolicy("lit-html", {
    createHTML: (s)=>s
});
const $b0ba4ea5b56b9ecc$var$commentMarker = ` ${(0, $c42ca2d32292a526$export$ffc4d0086f1a4c9)} `;
class $b0ba4ea5b56b9ecc$export$ce95ebd39b69fb27 {
    constructor(strings, values, type, processor){
        this.strings = strings;
        this.values = values;
        this.type = type;
        this.processor = processor;
    }
    /**
     * Returns a string of HTML used to create a `<template>` element.
     */ getHTML() {
        const l = this.strings.length - 1;
        let html = "";
        let isCommentBinding = false;
        for(let i = 0; i < l; i++){
            const s = this.strings[i];
            // For each binding we want to determine the kind of marker to insert
            // into the template source before it's parsed by the browser's HTML
            // parser. The marker type is based on whether the expression is in an
            // attribute, text, or comment position.
            //   * For node-position bindings we insert a comment with the marker
            //     sentinel as its text content, like <!--{{lit-guid}}-->.
            //   * For attribute bindings we insert just the marker sentinel for the
            //     first binding, so that we support unquoted attribute bindings.
            //     Subsequent bindings can use a comment marker because multi-binding
            //     attributes must be quoted.
            //   * For comment bindings we insert just the marker sentinel so we don't
            //     close the comment.
            //
            // The following code scans the template source, but is *not* an HTML
            // parser. We don't need to track the tree structure of the HTML, only
            // whether a binding is inside a comment, and if not, if it appears to be
            // the first binding in an attribute.
            const commentOpen = s.lastIndexOf("<!--");
            // We're in comment position if we have a comment open with no following
            // comment close. Because <-- can appear in an attribute value there can
            // be false positives.
            isCommentBinding = (commentOpen > -1 || isCommentBinding) && s.indexOf("-->", commentOpen + 1) === -1;
            // Check to see if we have an attribute-like sequence preceding the
            // expression. This can match "name=value" like structures in text,
            // comments, and attribute values, so there can be false-positives.
            const attributeMatch = (0, $c42ca2d32292a526$export$a5d53adfffe6a300).exec(s);
            if (attributeMatch === null) // We're only in this branch if we don't have a attribute-like
            // preceding sequence. For comments, this guards against unusual
            // attribute values like <div foo="<!--${'bar'}">. Cases like
            // <!-- foo=${'bar'}--> are handled correctly in the attribute branch
            // below.
            html += s + (isCommentBinding ? $b0ba4ea5b56b9ecc$var$commentMarker : (0, $c42ca2d32292a526$export$36b8314a2f34ed60));
            else // For attributes we use just a marker sentinel, and also append a
            // $lit$ suffix to the name to opt-out of attribute-specific parsing
            // that IE and Edge do for style and certain SVG attributes.
            html += s.substr(0, attributeMatch.index) + attributeMatch[1] + attributeMatch[2] + (0, $c42ca2d32292a526$export$552ff45b274cc170) + attributeMatch[3] + (0, $c42ca2d32292a526$export$ffc4d0086f1a4c9);
        }
        html += this.strings[l];
        return html;
    }
    getTemplateElement() {
        const template = document.createElement("template");
        let value = this.getHTML();
        if ($b0ba4ea5b56b9ecc$var$policy !== undefined) // this is secure because `this.strings` is a TemplateStringsArray.
        // TODO: validate this when
        // https://github.com/tc39/proposal-array-is-template-object is
        // implemented.
        value = $b0ba4ea5b56b9ecc$var$policy.createHTML(value);
        template.innerHTML = value;
        return template;
    }
}
class $b0ba4ea5b56b9ecc$export$36e852975bbbeae0 extends $b0ba4ea5b56b9ecc$export$ce95ebd39b69fb27 {
    getHTML() {
        return `<svg>${super.getHTML()}</svg>`;
    }
    getTemplateElement() {
        const template = super.getTemplateElement();
        const content = template.content;
        const svgElement = content.firstChild;
        content.removeChild(svgElement);
        (0, $739d7429d0e9ac82$export$4cae3494608af418)(content, svgElement.firstChild);
        return template;
    }
}



const $9115fb5260f5b78e$export$c3825b437cbdea5c = (value)=>{
    return value === null || !(typeof value === "object" || typeof value === "function");
};
const $9115fb5260f5b78e$export$9652023d9040757 = (value)=>{
    return Array.isArray(value) || // eslint-disable-next-line @typescript-eslint/no-explicit-any
    !!(value && value[Symbol.iterator]);
};
class $9115fb5260f5b78e$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        this.dirty = true;
        this.element = element;
        this.name = name;
        this.strings = strings;
        this.parts = [];
        for(let i = 0; i < strings.length - 1; i++)this.parts[i] = this._createPart();
    }
    /**
     * Creates a single part. Override this to create a differnt type of part.
     */ _createPart() {
        return new $9115fb5260f5b78e$export$da9b3ca39c846561(this);
    }
    _getValue() {
        const strings = this.strings;
        const l = strings.length - 1;
        const parts = this.parts;
        // If we're assigning an attribute via syntax like:
        //    attr="${foo}"  or  attr=${foo}
        // but not
        //    attr="${foo} ${bar}" or attr="${foo} baz"
        // then we don't want to coerce the attribute value into one long
        // string. Instead we want to just return the value itself directly,
        // so that sanitizeDOMValue can get the actual value rather than
        // String(value)
        // The exception is if v is an array, in which case we do want to smash
        // it together into a string without calling String() on the array.
        //
        // This also allows trusted values (when using TrustedTypes) being
        // assigned to DOM sinks without being stringified in the process.
        if (l === 1 && strings[0] === "" && strings[1] === "") {
            const v = parts[0].value;
            if (typeof v === "symbol") return String(v);
            if (typeof v === "string" || !$9115fb5260f5b78e$export$9652023d9040757(v)) return v;
        }
        let text = "";
        for(let i = 0; i < l; i++){
            text += strings[i];
            const part = parts[i];
            if (part !== undefined) {
                const v = part.value;
                if ($9115fb5260f5b78e$export$c3825b437cbdea5c(v) || !$9115fb5260f5b78e$export$9652023d9040757(v)) text += typeof v === "string" ? v : String(v);
                else for (const t of v)text += typeof t === "string" ? t : String(t);
            }
        }
        text += strings[l];
        return text;
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            this.element.setAttribute(this.name, this._getValue());
        }
    }
}
class $9115fb5260f5b78e$export$da9b3ca39c846561 {
    constructor(committer){
        this.value = undefined;
        this.committer = committer;
    }
    setValue(value) {
        if (value !== (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8) && (!$9115fb5260f5b78e$export$c3825b437cbdea5c(value) || value !== this.value)) {
            this.value = value;
            // If the value is a not a directive, dirty the committer so that it'll
            // call setAttribute. If the value is a directive, it'll dirty the
            // committer if it calls setValue().
            if (!(0, $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5)(value)) this.committer.dirty = true;
        }
    }
    commit() {
        while((0, $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5)(this.value)){
            const directive = this.value;
            this.value = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.value === (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8)) return;
        this.committer.commit();
    }
}
class $9115fb5260f5b78e$export$a354997aeda6e93 {
    constructor(options){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.options = options;
    }
    /**
     * Appends this part into a container.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendInto(container) {
        this.startNode = container.appendChild((0, $c42ca2d32292a526$export$46b32044f78fe9b1)());
        this.endNode = container.appendChild((0, $c42ca2d32292a526$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` node (between `ref` and `ref`'s next
     * sibling). Both `ref` and its next sibling must be static, unchanging nodes
     * such as those that appear in a literal section of a template.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterNode(ref) {
        this.startNode = ref;
        this.endNode = ref.nextSibling;
    }
    /**
     * Appends this part into a parent part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ appendIntoPart(part) {
        part.__insert(this.startNode = (0, $c42ca2d32292a526$export$46b32044f78fe9b1)());
        part.__insert(this.endNode = (0, $c42ca2d32292a526$export$46b32044f78fe9b1)());
    }
    /**
     * Inserts this part after the `ref` part.
     *
     * This part must be empty, as its contents are not automatically moved.
     */ insertAfterPart(ref) {
        ref.__insert(this.startNode = (0, $c42ca2d32292a526$export$46b32044f78fe9b1)());
        this.endNode = ref.endNode;
        ref.endNode = this.startNode;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        if (this.startNode.parentNode === null) return;
        while((0, $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
            directive(this);
        }
        const value = this.__pendingValue;
        if (value === (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8)) return;
        if ($9115fb5260f5b78e$export$c3825b437cbdea5c(value)) {
            if (value !== this.value) this.__commitText(value);
        } else if (value instanceof (0, $b0ba4ea5b56b9ecc$export$ce95ebd39b69fb27)) this.__commitTemplateResult(value);
        else if (value instanceof Node) this.__commitNode(value);
        else if ($9115fb5260f5b78e$export$9652023d9040757(value)) this.__commitIterable(value);
        else if (value === (0, $416fcdb557dd27f4$export$45b790e32b2810ee)) {
            this.value = (0, $416fcdb557dd27f4$export$45b790e32b2810ee);
            this.clear();
        } else // Fallback, will render the string representation
        this.__commitText(value);
    }
    __insert(node) {
        this.endNode.parentNode.insertBefore(node, this.endNode);
    }
    __commitNode(value) {
        if (this.value === value) return;
        this.clear();
        this.__insert(value);
        this.value = value;
    }
    __commitText(value) {
        const node = this.startNode.nextSibling;
        value = value == null ? "" : value;
        // If `value` isn't already a string, we explicitly convert it here in case
        // it can't be implicitly converted - i.e. it's a symbol.
        const valueAsString = typeof value === "string" ? value : String(value);
        if (node === this.endNode.previousSibling && node.nodeType === 3 /* Node.TEXT_NODE */ ) // If we only have a single text node between the markers, we can just
        // set its value, rather than replacing it.
        // TODO(justinfagnani): Can we just check if this.value is primitive?
        node.data = valueAsString;
        else this.__commitNode(document.createTextNode(valueAsString));
        this.value = value;
    }
    __commitTemplateResult(value) {
        const template = this.options.templateFactory(value);
        if (this.value instanceof (0, $5900699a09154d62$export$6eecef7813f38266) && this.value.template === template) this.value.update(value.values);
        else {
            // Make sure we propagate the template processor from the TemplateResult
            // so that we use its syntax extension, etc. The template factory comes
            // from the render function options so that it can control template
            // caching and preprocessing.
            const instance = new (0, $5900699a09154d62$export$6eecef7813f38266)(template, value.processor, this.options);
            const fragment = instance._clone();
            instance.update(value.values);
            this.__commitNode(fragment);
            this.value = instance;
        }
    }
    __commitIterable(value) {
        // For an Iterable, we create a new InstancePart per item, then set its
        // value to the item. This is a little bit of overhead for every item in
        // an Iterable, but it lets us recurse easily and efficiently update Arrays
        // of TemplateResults that will be commonly returned from expressions like:
        // array.map((i) => html`${i}`), by reusing existing TemplateInstances.
        // If _value is an array, then the previous render was of an
        // iterable and _value will contain the NodeParts from the previous
        // render. If _value is not an array, clear this part and make a new
        // array for NodeParts.
        if (!Array.isArray(this.value)) {
            this.value = [];
            this.clear();
        }
        // Lets us keep track of how many items we stamped so we can clear leftover
        // items from a previous render
        const itemParts = this.value;
        let partIndex = 0;
        let itemPart;
        for (const item of value){
            // Try to reuse an existing part
            itemPart = itemParts[partIndex];
            // If no existing part, create a new one
            if (itemPart === undefined) {
                itemPart = new $9115fb5260f5b78e$export$a354997aeda6e93(this.options);
                itemParts.push(itemPart);
                if (partIndex === 0) itemPart.appendIntoPart(this);
                else itemPart.insertAfterPart(itemParts[partIndex - 1]);
            }
            itemPart.setValue(item);
            itemPart.commit();
            partIndex++;
        }
        if (partIndex < itemParts.length) {
            // Truncate the parts array so _value reflects the current state
            itemParts.length = partIndex;
            this.clear(itemPart && itemPart.endNode);
        }
    }
    clear(startNode = this.startNode) {
        (0, $739d7429d0e9ac82$export$77f49a256021c8de)(this.startNode.parentNode, startNode.nextSibling, this.endNode);
    }
}
class $9115fb5260f5b78e$export$b9df278b293d5b48 {
    constructor(element, name, strings){
        this.value = undefined;
        this.__pendingValue = undefined;
        if (strings.length !== 2 || strings[0] !== "" || strings[1] !== "") throw new Error("Boolean attributes can only contain a single expression");
        this.element = element;
        this.name = name;
        this.strings = strings;
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8)) return;
        const value = !!this.__pendingValue;
        if (this.value !== value) {
            if (value) this.element.setAttribute(this.name, "");
            else this.element.removeAttribute(this.name);
            this.value = value;
        }
        this.__pendingValue = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
    }
}
class $9115fb5260f5b78e$export$2d7935a96ad7cb22 extends $9115fb5260f5b78e$export$9ac9216e336e96d0 {
    constructor(element, name, strings){
        super(element, name, strings);
        this.single = strings.length === 2 && strings[0] === "" && strings[1] === "";
    }
    _createPart() {
        return new $9115fb5260f5b78e$export$b78f5e1c476c794e(this);
    }
    _getValue() {
        if (this.single) return this.parts[0].value;
        return super._getValue();
    }
    commit() {
        if (this.dirty) {
            this.dirty = false;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.element[this.name] = this._getValue();
        }
    }
}
class $9115fb5260f5b78e$export$b78f5e1c476c794e extends $9115fb5260f5b78e$export$da9b3ca39c846561 {
}
// Detect event listener options support. If the `capture` property is read
// from the options object, then options are supported. If not, then the third
// argument to add/removeEventListener is interpreted as the boolean capture
// value so we should only pass the `capture` property.
let $9115fb5260f5b78e$var$eventOptionsSupported = false;
// Wrap into an IIFE because MS Edge <= v41 does not support having try/catch
// blocks right into the body of a module
(()=>{
    try {
        const options = {
            get capture () {
                $9115fb5260f5b78e$var$eventOptionsSupported = true;
                return false;
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.addEventListener("test", options, options);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.removeEventListener("test", options, options);
    } catch (_e) {
    // event options not supported
    }
})();
class $9115fb5260f5b78e$export$b28e368652651bd7 {
    constructor(element, eventName, eventContext){
        this.value = undefined;
        this.__pendingValue = undefined;
        this.element = element;
        this.eventName = eventName;
        this.eventContext = eventContext;
        this.__boundHandleEvent = (e)=>this.handleEvent(e);
    }
    setValue(value) {
        this.__pendingValue = value;
    }
    commit() {
        while((0, $3e8bd64d8ced9af7$export$4b5d79f26e0e3ad5)(this.__pendingValue)){
            const directive = this.__pendingValue;
            this.__pendingValue = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
            directive(this);
        }
        if (this.__pendingValue === (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8)) return;
        const newListener = this.__pendingValue;
        const oldListener = this.value;
        const shouldRemoveListener = newListener == null || oldListener != null && (newListener.capture !== oldListener.capture || newListener.once !== oldListener.once || newListener.passive !== oldListener.passive);
        const shouldAddListener = newListener != null && (oldListener == null || shouldRemoveListener);
        if (shouldRemoveListener) this.element.removeEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        if (shouldAddListener) {
            this.__options = $9115fb5260f5b78e$var$getOptions(newListener);
            this.element.addEventListener(this.eventName, this.__boundHandleEvent, this.__options);
        }
        this.value = newListener;
        this.__pendingValue = (0, $416fcdb557dd27f4$export$9c068ae9cc5db4e8);
    }
    handleEvent(event) {
        if (typeof this.value === "function") this.value.call(this.eventContext || this.element, event);
        else this.value.handleEvent(event);
    }
}
// We copy options because of the inconsistent behavior of browsers when reading
// the third argument of add/removeEventListener. IE11 doesn't support options
// at all. Chrome 41 only reads `capture` if the argument is an object.
const $9115fb5260f5b78e$var$getOptions = (o)=>o && ($9115fb5260f5b78e$var$eventOptionsSupported ? {
        capture: o.capture,
        passive: o.passive,
        once: o.once
    } : o.capture);


class $801ef34ed3213e0e$export$53a556099f0fa088 {
    /**
     * Create parts for an attribute-position binding, given the event, attribute
     * name, and string literals.
     *
     * @param element The element containing the binding
     * @param name  The attribute name
     * @param strings The string literals. There are always at least two strings,
     *   event for fully-controlled bindings with a single expression.
     */ handleAttributeExpressions(element, name, strings, options) {
        const prefix = name[0];
        if (prefix === ".") {
            const committer = new (0, $9115fb5260f5b78e$export$2d7935a96ad7cb22)(element, name.slice(1), strings);
            return committer.parts;
        }
        if (prefix === "@") return [
            new (0, $9115fb5260f5b78e$export$b28e368652651bd7)(element, name.slice(1), options.eventContext)
        ];
        if (prefix === "?") return [
            new (0, $9115fb5260f5b78e$export$b9df278b293d5b48)(element, name.slice(1), strings)
        ];
        const committer = new (0, $9115fb5260f5b78e$export$9ac9216e336e96d0)(element, name, strings);
        return committer.parts;
    }
    /**
     * Create parts for a text-position binding.
     * @param templateFactory
     */ handleTextExpression(options) {
        return new (0, $9115fb5260f5b78e$export$a354997aeda6e93)(options);
    }
}
const $801ef34ed3213e0e$export$608256e8e6650f65 = new $801ef34ed3213e0e$export$53a556099f0fa088();







/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 

/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
function $a5fe4f14b8d39ea2$export$ac8809ff023de002(result) {
    let templateCache = $a5fe4f14b8d39ea2$export$f4a9a5e9f571ddee.get(result.type);
    if (templateCache === undefined) {
        templateCache = {
            stringsArray: new WeakMap(),
            keyString: new Map()
        };
        $a5fe4f14b8d39ea2$export$f4a9a5e9f571ddee.set(result.type, templateCache);
    }
    let template = templateCache.stringsArray.get(result.strings);
    if (template !== undefined) return template;
    // If the TemplateStringsArray is new, generate a key from the strings
    // This key is shared between all templates with identical content
    const key = result.strings.join((0, $c42ca2d32292a526$export$ffc4d0086f1a4c9));
    // Check if we already have a Template for this key
    template = templateCache.keyString.get(key);
    if (template === undefined) {
        // If we have not seen this key before, create a new Template
        template = new (0, $c42ca2d32292a526$export$14416b8d99d47caa)(result, result.getTemplateElement());
        // Cache the Template for this key
        templateCache.keyString.set(key, template);
    }
    // Cache all future queries for this TemplateStringsArray
    templateCache.stringsArray.set(result.strings, template);
    return template;
}
const $a5fe4f14b8d39ea2$export$f4a9a5e9f571ddee = new Map();


const $ca64cbbfd570e12d$export$6e2410c1d27f06e7 = new WeakMap();
const $ca64cbbfd570e12d$export$b3890eb0ae9dca99 = (result, container, options)=>{
    let part = $ca64cbbfd570e12d$export$6e2410c1d27f06e7.get(container);
    if (part === undefined) {
        (0, $739d7429d0e9ac82$export$77f49a256021c8de)(container, container.firstChild);
        $ca64cbbfd570e12d$export$6e2410c1d27f06e7.set(container, part = new (0, $9115fb5260f5b78e$export$a354997aeda6e93)(Object.assign({
            templateFactory: $a5fe4f14b8d39ea2$export$ac8809ff023de002
        }, options)));
        part.appendInto(container);
    }
    part.setValue(result);
    part.commit();
};





// IMPORTANT: do not change the property name or the assignment expression.
// This line will be used in regexes to search for lit-html usage.
// TODO(justinfagnani): inject version number at build time
if (typeof window !== "undefined") (window["litHtmlVersions"] || (window["litHtmlVersions"] = [])).push("1.4.1");
const $e5ed8027d647799b$export$c0bb0b647f701bb5 = (strings, ...values)=>new (0, $b0ba4ea5b56b9ecc$export$ce95ebd39b69fb27)(strings, values, "html", (0, $801ef34ed3213e0e$export$608256e8e6650f65));
const $e5ed8027d647799b$export$7ed1367e7fa1ad68 = (strings, ...values)=>new (0, $b0ba4ea5b56b9ecc$export$36e852975bbbeae0)(strings, values, "svg", (0, $801ef34ed3213e0e$export$608256e8e6650f65));


/**
 * @license
 * Copyright (c) 2017 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
// Helper functions for manipulating parts
// TODO(kschaaf): Refactor into Part API?
const $e41d1b66de65ecc4$var$createAndInsertPart = (containerPart, beforePart)=>{
    const container = containerPart.startNode.parentNode;
    const beforeNode = beforePart === undefined ? containerPart.endNode : beforePart.startNode;
    const startNode = container.insertBefore((0, $c42ca2d32292a526$export$46b32044f78fe9b1)(), beforeNode);
    container.insertBefore((0, $c42ca2d32292a526$export$46b32044f78fe9b1)(), beforeNode);
    const newPart = new (0, $9115fb5260f5b78e$export$a354997aeda6e93)(containerPart.options);
    newPart.insertAfterNode(startNode);
    return newPart;
};
const $e41d1b66de65ecc4$var$updatePart = (part, value)=>{
    part.setValue(value);
    part.commit();
    return part;
};
const $e41d1b66de65ecc4$var$insertPartBefore = (containerPart, part, ref)=>{
    const container = containerPart.startNode.parentNode;
    const beforeNode = ref ? ref.startNode : containerPart.endNode;
    const endNode = part.endNode.nextSibling;
    if (endNode !== beforeNode) (0, $739d7429d0e9ac82$export$4cae3494608af418)(container, part.startNode, endNode, beforeNode);
};
const $e41d1b66de65ecc4$var$removePart = (part)=>{
    (0, $739d7429d0e9ac82$export$77f49a256021c8de)(part.startNode.parentNode, part.startNode, part.endNode.nextSibling);
};
// Helper for generating a map of array item to its index over a subset
// of an array (used to lazily generate `newKeyToIndexMap` and
// `oldKeyToIndexMap`)
const $e41d1b66de65ecc4$var$generateMap = (list, start, end)=>{
    const map = new Map();
    for(let i = start; i <= end; i++)map.set(list[i], i);
    return map;
};
// Stores previous ordered list of parts and map of key to index
const $e41d1b66de65ecc4$var$partListCache = new WeakMap();
const $e41d1b66de65ecc4$var$keyListCache = new WeakMap();
const $e41d1b66de65ecc4$export$76d90c956114f2c2 = (0, $3e8bd64d8ced9af7$export$99b43ad1ed32e735)((items, keyFnOrTemplate, template)=>{
    let keyFn;
    if (template === undefined) template = keyFnOrTemplate;
    else if (keyFnOrTemplate !== undefined) keyFn = keyFnOrTemplate;
    return (containerPart)=>{
        if (!(containerPart instanceof (0, $9115fb5260f5b78e$export$a354997aeda6e93))) throw new Error("repeat can only be used in text bindings");
        // Old part & key lists are retrieved from the last update
        // (associated with the part for this instance of the directive)
        const oldParts = $e41d1b66de65ecc4$var$partListCache.get(containerPart) || [];
        const oldKeys = $e41d1b66de65ecc4$var$keyListCache.get(containerPart) || [];
        // New part list will be built up as we go (either reused from
        // old parts or created for new keys in this update). This is
        // saved in the above cache at the end of the update.
        const newParts = [];
        // New value list is eagerly generated from items along with a
        // parallel array indicating its key.
        const newValues = [];
        const newKeys = [];
        let index = 0;
        for (const item of items){
            newKeys[index] = keyFn ? keyFn(item, index) : index;
            newValues[index] = template(item, index);
            index++;
        }
        // Maps from key to index for current and previous update; these
        // are generated lazily only when needed as a performance
        // optimization, since they are only required for multiple
        // non-contiguous changes in the list, which are less common.
        let newKeyToIndexMap;
        let oldKeyToIndexMap;
        // Head and tail pointers to old parts and new values
        let oldHead = 0;
        let oldTail = oldParts.length - 1;
        let newHead = 0;
        let newTail = newValues.length - 1;
        // Overview of O(n) reconciliation algorithm (general approach
        // based on ideas found in ivi, vue, snabbdom, etc.):
        //
        // * We start with the list of old parts and new values (and
        //   arrays of their respective keys), head/tail pointers into
        //   each, and we build up the new list of parts by updating
        //   (and when needed, moving) old parts or creating new ones.
        //   The initial scenario might look like this (for brevity of
        //   the diagrams, the numbers in the array reflect keys
        //   associated with the old parts or new values, although keys
        //   and parts/values are actually stored in parallel arrays
        //   indexed using the same head/tail pointers):
        //
        //      oldHead v                 v oldTail
        //   oldKeys:  [0, 1, 2, 3, 4, 5, 6]
        //   newParts: [ ,  ,  ,  ,  ,  ,  ]
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6] <- reflects the user's new
        //                                      item order
        //      newHead ^                 ^ newTail
        //
        // * Iterate old & new lists from both sides, updating,
        //   swapping, or removing parts at the head/tail locations
        //   until neither head nor tail can move.
        //
        // * Example below: keys at head pointers match, so update old
        //   part 0 in-place (no need to move it) and record part 0 in
        //   the `newParts` list. The last thing we do is advance the
        //   `oldHead` and `newHead` pointers (will be reflected in the
        //   next diagram).
        //
        //      oldHead v                 v oldTail
        //   oldKeys:  [0, 1, 2, 3, 4, 5, 6]
        //   newParts: [0,  ,  ,  ,  ,  ,  ] <- heads matched: update 0
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    and advance both oldHead
        //                                      & newHead
        //      newHead ^                 ^ newTail
        //
        // * Example below: head pointers don't match, but tail
        //   pointers do, so update part 6 in place (no need to move
        //   it), and record part 6 in the `newParts` list. Last,
        //   advance the `oldTail` and `oldHead` pointers.
        //
        //         oldHead v              v oldTail
        //   oldKeys:  [0, 1, 2, 3, 4, 5, 6]
        //   newParts: [0,  ,  ,  ,  ,  , 6] <- tails matched: update 6
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    and advance both oldTail
        //                                      & newTail
        //         newHead ^              ^ newTail
        //
        // * If neither head nor tail match; next check if one of the
        //   old head/tail items was removed. We first need to generate
        //   the reverse map of new keys to index (`newKeyToIndexMap`),
        //   which is done once lazily as a performance optimization,
        //   since we only hit this case if multiple non-contiguous
        //   changes were made. Note that for contiguous removal
        //   anywhere in the list, the head and tails would advance
        //   from either end and pass each other before we get to this
        //   case and removals would be handled in the final while loop
        //   without needing to generate the map.
        //
        // * Example below: The key at `oldTail` was removed (no longer
        //   in the `newKeyToIndexMap`), so remove that part from the
        //   DOM and advance just the `oldTail` pointer.
        //
        //         oldHead v           v oldTail
        //   oldKeys:  [0, 1, 2, 3, 4, 5, 6]
        //   newParts: [0,  ,  ,  ,  ,  , 6] <- 5 not in new map: remove
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    5 and advance oldTail
        //         newHead ^           ^ newTail
        //
        // * Once head and tail cannot move, any mismatches are due to
        //   either new or moved items; if a new key is in the previous
        //   "old key to old index" map, move the old part to the new
        //   location, otherwise create and insert a new part. Note
        //   that when moving an old part we null its position in the
        //   oldParts array if it lies between the head and tail so we
        //   know to skip it when the pointers get there.
        //
        // * Example below: neither head nor tail match, and neither
        //   were removed; so find the `newHead` key in the
        //   `oldKeyToIndexMap`, and move that old part's DOM into the
        //   next head position (before `oldParts[oldHead]`). Last,
        //   null the part in the `oldPart` array since it was
        //   somewhere in the remaining oldParts still to be scanned
        //   (between the head and tail pointers) so that we know to
        //   skip that old part on future iterations.
        //
        //         oldHead v        v oldTail
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6]
        //   newParts: [0, 2,  ,  ,  ,  , 6] <- stuck: update & move 2
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    into place and advance
        //                                      newHead
        //         newHead ^           ^ newTail
        //
        // * Note that for moves/insertions like the one above, a part
        //   inserted at the head pointer is inserted before the
        //   current `oldParts[oldHead]`, and a part inserted at the
        //   tail pointer is inserted before `newParts[newTail+1]`. The
        //   seeming asymmetry lies in the fact that new parts are
        //   moved into place outside in, so to the right of the head
        //   pointer are old parts, and to the right of the tail
        //   pointer are new parts.
        //
        // * We always restart back from the top of the algorithm,
        //   allowing matching and simple updates in place to
        //   continue...
        //
        // * Example below: the head pointers once again match, so
        //   simply update part 1 and record it in the `newParts`
        //   array.  Last, advance both head pointers.
        //
        //         oldHead v        v oldTail
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6]
        //   newParts: [0, 2, 1,  ,  ,  , 6] <- heads matched: update 1
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    and advance both oldHead
        //                                      & newHead
        //            newHead ^        ^ newTail
        //
        // * As mentioned above, items that were moved as a result of
        //   being stuck (the final else clause in the code below) are
        //   marked with null, so we always advance old pointers over
        //   these so we're comparing the next actual old value on
        //   either end.
        //
        // * Example below: `oldHead` is null (already placed in
        //   newParts), so advance `oldHead`.
        //
        //            oldHead v     v oldTail
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6] <- old head already used:
        //   newParts: [0, 2, 1,  ,  ,  , 6]    advance oldHead
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]
        //               newHead ^     ^ newTail
        //
        // * Note it's not critical to mark old parts as null when they
        //   are moved from head to tail or tail to head, since they
        //   will be outside the pointer range and never visited again.
        //
        // * Example below: Here the old tail key matches the new head
        //   key, so the part at the `oldTail` position and move its
        //   DOM to the new head position (before `oldParts[oldHead]`).
        //   Last, advance `oldTail` and `newHead` pointers.
        //
        //               oldHead v  v oldTail
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6]
        //   newParts: [0, 2, 1, 4,  ,  , 6] <- old tail matches new
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]   head: update & move 4,
        //                                     advance oldTail & newHead
        //               newHead ^     ^ newTail
        //
        // * Example below: Old and new head keys match, so update the
        //   old head part in place, and advance the `oldHead` and
        //   `newHead` pointers.
        //
        //               oldHead v oldTail
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6]
        //   newParts: [0, 2, 1, 4, 3,   ,6] <- heads match: update 3
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]    and advance oldHead &
        //                                      newHead
        //                  newHead ^  ^ newTail
        //
        // * Once the new or old pointers move past each other then all
        //   we have left is additions (if old list exhausted) or
        //   removals (if new list exhausted). Those are handled in the
        //   final while loops at the end.
        //
        // * Example below: `oldHead` exceeded `oldTail`, so we're done
        //   with the main loop.  Create the remaining part and insert
        //   it at the new head position, and the update is complete.
        //
        //                   (oldHead > oldTail)
        //   oldKeys:  [0, 1, -, 3, 4, 5, 6]
        //   newParts: [0, 2, 1, 4, 3, 7 ,6] <- create and insert 7
        //   newKeys:  [0, 2, 1, 4, 3, 7, 6]
        //                     newHead ^ newTail
        //
        // * Note that the order of the if/else clauses is not
        //   important to the algorithm, as long as the null checks
        //   come first (to ensure we're always working on valid old
        //   parts) and that the final else clause comes last (since
        //   that's where the expensive moves occur). The order of
        //   remaining clauses is is just a simple guess at which cases
        //   will be most common.
        //
        // * TODO(kschaaf) Note, we could calculate the longest
        //   increasing subsequence (LIS) of old items in new position,
        //   and only move those not in the LIS set. However that costs
        //   O(nlogn) time and adds a bit more code, and only helps
        //   make rare types of mutations require fewer moves. The
        //   above handles removes, adds, reversal, swaps, and single
        //   moves of contiguous items in linear time, in the minimum
        //   number of moves. As the number of multiple moves where LIS
        //   might help approaches a random shuffle, the LIS
        //   optimization becomes less helpful, so it seems not worth
        //   the code at this point. Could reconsider if a compelling
        //   case arises.
        while(oldHead <= oldTail && newHead <= newTail){
            if (oldParts[oldHead] === null) // `null` means old part at head has already been used
            // below; skip
            oldHead++;
            else if (oldParts[oldTail] === null) // `null` means old part at tail has already been used
            // below; skip
            oldTail--;
            else if (oldKeys[oldHead] === newKeys[newHead]) {
                // Old head matches new head; update in place
                newParts[newHead] = $e41d1b66de65ecc4$var$updatePart(oldParts[oldHead], newValues[newHead]);
                oldHead++;
                newHead++;
            } else if (oldKeys[oldTail] === newKeys[newTail]) {
                // Old tail matches new tail; update in place
                newParts[newTail] = $e41d1b66de65ecc4$var$updatePart(oldParts[oldTail], newValues[newTail]);
                oldTail--;
                newTail--;
            } else if (oldKeys[oldHead] === newKeys[newTail]) {
                // Old head matches new tail; update and move to new tail
                newParts[newTail] = $e41d1b66de65ecc4$var$updatePart(oldParts[oldHead], newValues[newTail]);
                $e41d1b66de65ecc4$var$insertPartBefore(containerPart, oldParts[oldHead], newParts[newTail + 1]);
                oldHead++;
                newTail--;
            } else if (oldKeys[oldTail] === newKeys[newHead]) {
                // Old tail matches new head; update and move to new head
                newParts[newHead] = $e41d1b66de65ecc4$var$updatePart(oldParts[oldTail], newValues[newHead]);
                $e41d1b66de65ecc4$var$insertPartBefore(containerPart, oldParts[oldTail], oldParts[oldHead]);
                oldTail--;
                newHead++;
            } else {
                if (newKeyToIndexMap === undefined) {
                    // Lazily generate key-to-index maps, used for removals &
                    // moves below
                    newKeyToIndexMap = $e41d1b66de65ecc4$var$generateMap(newKeys, newHead, newTail);
                    oldKeyToIndexMap = $e41d1b66de65ecc4$var$generateMap(oldKeys, oldHead, oldTail);
                }
                if (!newKeyToIndexMap.has(oldKeys[oldHead])) {
                    // Old head is no longer in new list; remove
                    $e41d1b66de65ecc4$var$removePart(oldParts[oldHead]);
                    oldHead++;
                } else if (!newKeyToIndexMap.has(oldKeys[oldTail])) {
                    // Old tail is no longer in new list; remove
                    $e41d1b66de65ecc4$var$removePart(oldParts[oldTail]);
                    oldTail--;
                } else {
                    // Any mismatches at this point are due to additions or
                    // moves; see if we have an old part we can reuse and move
                    // into place
                    const oldIndex = oldKeyToIndexMap.get(newKeys[newHead]);
                    const oldPart = oldIndex !== undefined ? oldParts[oldIndex] : null;
                    if (oldPart === null) {
                        // No old part for this value; create a new one and
                        // insert it
                        const newPart = $e41d1b66de65ecc4$var$createAndInsertPart(containerPart, oldParts[oldHead]);
                        $e41d1b66de65ecc4$var$updatePart(newPart, newValues[newHead]);
                        newParts[newHead] = newPart;
                    } else {
                        // Reuse old part
                        newParts[newHead] = $e41d1b66de65ecc4$var$updatePart(oldPart, newValues[newHead]);
                        $e41d1b66de65ecc4$var$insertPartBefore(containerPart, oldPart, oldParts[oldHead]);
                        // This marks the old part as having been used, so that
                        // it will be skipped in the first two checks above
                        oldParts[oldIndex] = null;
                    }
                    newHead++;
                }
            }
        }
        // Add parts for any remaining new values
        while(newHead <= newTail){
            // For all remaining additions, we insert before last new
            // tail, since old pointers are no longer valid
            const newPart = $e41d1b66de65ecc4$var$createAndInsertPart(containerPart, newParts[newTail + 1]);
            $e41d1b66de65ecc4$var$updatePart(newPart, newValues[newHead]);
            newParts[newHead++] = newPart;
        }
        // Remove any remaining unused old parts
        while(oldHead <= oldTail){
            const oldPart = oldParts[oldHead++];
            if (oldPart !== null) $e41d1b66de65ecc4$var$removePart(oldPart);
        }
        // Save order of new parts for next round
        $e41d1b66de65ecc4$var$partListCache.set(containerPart, newParts);
        $e41d1b66de65ecc4$var$keyListCache.set(containerPart, newKeys);
    };
});


/*! @license Rematrix v0.7.2

	Copyright 2021 Julian Lloyd.

	Permission is hereby granted, free of charge, to any person obtaining a copy
	of this software and associated documentation files (the "Software"), to deal
	in the Software without restriction, including without limitation the rights
	to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the Software is
	furnished to do so, subject to the following conditions:

	The above copyright notice and this permission notice shall be included in
	all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	THE SOFTWARE.
*/ function $cfbcedb4befb73c9$export$d9468344d3651243(source) {
    if (source && source.constructor === Array) {
        var values = source.filter(function(value) {
            return typeof value === "number";
        }).filter(function(value) {
            return !isNaN(value);
        });
        if (source.length === 6 && values.length === 6) {
            var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
            matrix[0] = values[0];
            matrix[1] = values[1];
            matrix[4] = values[2];
            matrix[5] = values[3];
            matrix[12] = values[4];
            matrix[13] = values[5];
            return matrix;
        } else if (source.length === 16 && values.length === 16) return source;
    }
    throw new TypeError("Expected a `number[]` with length 6 or 16.");
}
function $cfbcedb4befb73c9$export$3004f64547af360e(source) {
    if (typeof source === "string") {
        var match = source.match(/matrix(3d)?\(([^)]+)\)/);
        if (match) {
            var raw = match[2].split(",").map(parseFloat);
            return $cfbcedb4befb73c9$export$d9468344d3651243(raw);
        }
        if (source === "none" || source === "") return $cfbcedb4befb73c9$export$f0954fd7d5368655();
    }
    throw new TypeError("Expected a string containing `matrix()` or `matrix3d()");
}
function $cfbcedb4befb73c9$export$f0954fd7d5368655() {
    var matrix = [];
    for(var i = 0; i < 16; i++)i % 5 == 0 ? matrix.push(1) : matrix.push(0);
    return matrix;
}
function $cfbcedb4befb73c9$export$70ae2c07e401031b(source) {
    var m = $cfbcedb4befb73c9$export$d9468344d3651243(source);
    var s0 = m[0] * m[5] - m[4] * m[1];
    var s1 = m[0] * m[6] - m[4] * m[2];
    var s2 = m[0] * m[7] - m[4] * m[3];
    var s3 = m[1] * m[6] - m[5] * m[2];
    var s4 = m[1] * m[7] - m[5] * m[3];
    var s5 = m[2] * m[7] - m[6] * m[3];
    var c5 = m[10] * m[15] - m[14] * m[11];
    var c4 = m[9] * m[15] - m[13] * m[11];
    var c3 = m[9] * m[14] - m[13] * m[10];
    var c2 = m[8] * m[15] - m[12] * m[11];
    var c1 = m[8] * m[14] - m[12] * m[10];
    var c0 = m[8] * m[13] - m[12] * m[9];
    var determinant = 1 / (s0 * c5 - s1 * c4 + s2 * c3 + s3 * c2 - s4 * c1 + s5 * c0);
    if (isNaN(determinant) || determinant === Infinity) throw new Error("Inverse determinant attempted to divide by zero.");
    return [
        (m[5] * c5 - m[6] * c4 + m[7] * c3) * determinant,
        (-m[1] * c5 + m[2] * c4 - m[3] * c3) * determinant,
        (m[13] * s5 - m[14] * s4 + m[15] * s3) * determinant,
        (-m[9] * s5 + m[10] * s4 - m[11] * s3) * determinant,
        (-m[4] * c5 + m[6] * c2 - m[7] * c1) * determinant,
        (m[0] * c5 - m[2] * c2 + m[3] * c1) * determinant,
        (-m[12] * s5 + m[14] * s2 - m[15] * s1) * determinant,
        (m[8] * s5 - m[10] * s2 + m[11] * s1) * determinant,
        (m[4] * c4 - m[5] * c2 + m[7] * c0) * determinant,
        (-m[0] * c4 + m[1] * c2 - m[3] * c0) * determinant,
        (m[12] * s4 - m[13] * s2 + m[15] * s0) * determinant,
        (-m[8] * s4 + m[9] * s2 - m[11] * s0) * determinant,
        (-m[4] * c3 + m[5] * c1 - m[6] * c0) * determinant,
        (m[0] * c3 - m[1] * c1 + m[2] * c0) * determinant,
        (-m[12] * s3 + m[13] * s1 - m[14] * s0) * determinant,
        (m[8] * s3 - m[9] * s1 + m[10] * s0) * determinant
    ];
}
function $cfbcedb4befb73c9$export$2060d2db72cce88f(matrixA, matrixB) {
    var fma = $cfbcedb4befb73c9$export$d9468344d3651243(matrixA);
    var fmb = $cfbcedb4befb73c9$export$d9468344d3651243(matrixB);
    var product = [];
    for(var i = 0; i < 4; i++){
        var row = [
            fma[i],
            fma[i + 4],
            fma[i + 8],
            fma[i + 12]
        ];
        for(var j = 0; j < 4; j++){
            var k = j * 4;
            var col = [
                fmb[k],
                fmb[k + 1],
                fmb[k + 2],
                fmb[k + 3]
            ];
            var result = row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];
            product[i + k] = result;
        }
    }
    return product;
}
function $cfbcedb4befb73c9$export$541149539f3a4684(distance) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[11] = -1 / distance;
    return matrix;
}
function $cfbcedb4befb73c9$export$bb628a54ab399bc9(angle) {
    return $cfbcedb4befb73c9$export$ea6eae3365de5b9c(angle);
}
function $cfbcedb4befb73c9$export$a59c8716592e09af(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[5] = matrix[10] = Math.cos(theta);
    matrix[6] = matrix[9] = Math.sin(theta);
    matrix[9] *= -1;
    return matrix;
}
function $cfbcedb4befb73c9$export$cf71e4d4ca4d1cfd(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[0] = matrix[10] = Math.cos(theta);
    matrix[2] = matrix[8] = Math.sin(theta);
    matrix[2] *= -1;
    return matrix;
}
function $cfbcedb4befb73c9$export$ea6eae3365de5b9c(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[0] = matrix[5] = Math.cos(theta);
    matrix[1] = matrix[4] = Math.sin(theta);
    matrix[4] *= -1;
    return matrix;
}
function $cfbcedb4befb73c9$export$dcdf75081b88279d(scalar, scalarY) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[0] = scalar;
    matrix[5] = typeof scalarY === "number" ? scalarY : scalar;
    return matrix;
}
function $cfbcedb4befb73c9$export$55295ade51f88202(scalar) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[0] = scalar;
    return matrix;
}
function $cfbcedb4befb73c9$export$2092e2a44ac13bb2(scalar) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[5] = scalar;
    return matrix;
}
function $cfbcedb4befb73c9$export$13034b1ece9569d5(scalar) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[10] = scalar;
    return matrix;
}
function $cfbcedb4befb73c9$export$dd2d5a892675faf1(angleX, angleY) {
    var thetaX = Math.PI / 180 * angleX;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[4] = Math.tan(thetaX);
    if (angleY) {
        var thetaY = Math.PI / 180 * angleY;
        matrix[1] = Math.tan(thetaY);
    }
    return matrix;
}
function $cfbcedb4befb73c9$export$e446fc4c2803fd1b(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[4] = Math.tan(theta);
    return matrix;
}
function $cfbcedb4befb73c9$export$1649e48e73861f36(angle) {
    var theta = Math.PI / 180 * angle;
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[1] = Math.tan(theta);
    return matrix;
}
function $cfbcedb4befb73c9$export$f84e8e69fd4488a5(source) {
    return "matrix3d(" + $cfbcedb4befb73c9$export$d9468344d3651243(source).join(", ") + ")";
}
function $cfbcedb4befb73c9$export$d73ee8ef04f5226a(distanceX, distanceY) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[12] = distanceX;
    if (distanceY) matrix[13] = distanceY;
    return matrix;
}
function $cfbcedb4befb73c9$export$8327bb6724cad7c6(distanceX, distanceY, distanceZ) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    if (distanceX !== undefined && distanceY !== undefined && distanceZ !== undefined) {
        matrix[12] = distanceX;
        matrix[13] = distanceY;
        matrix[14] = distanceZ;
    }
    return matrix;
}
function $cfbcedb4befb73c9$export$5667f2d3f182f284(distance) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[12] = distance;
    return matrix;
}
function $cfbcedb4befb73c9$export$a1f0f3245f0cf0a4(distance) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[13] = distance;
    return matrix;
}
function $cfbcedb4befb73c9$export$6e43fd17fc519956(distance) {
    var matrix = $cfbcedb4befb73c9$export$f0954fd7d5368655();
    matrix[14] = distance;
    return matrix;
}


const $2a9f999bc54a0719$export$4051a07651545597 = {
    items: [
        {
            id: "item-1",
            index: 0,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
            ],
            thumb: "//picsum.photos/id/200/500/700",
            name: "Big Buck Bunny"
        },
        {
            id: "item-2",
            index: 1,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
            ],
            thumb: "//picsum.photos/id/201/500/700",
            name: "Elephant Dream"
        },
        {
            id: "item-3",
            index: 2,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
            ],
            thumb: "//picsum.photos/id/202/500/700",
            name: "For Bigger Blazes"
        },
        {
            id: "item-4",
            index: 3,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4"
            ],
            thumb: "//picsum.photos/id/203/500/700",
            name: "For Bigger Escape"
        },
        {
            id: "item-5",
            index: 4,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4"
            ],
            thumb: "//picsum.photos/id/204/500/700",
            name: "For Bigger Fun"
        },
        {
            id: "item-6",
            index: 5,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"
            ],
            thumb: "//picsum.photos/id/305/500/700",
            name: "For Bigger Joyrides"
        },
        {
            id: "item-7",
            index: 6,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4"
            ],
            thumb: "//picsum.photos/id/206/500/700",
            name: "For Bigger Meltdowns"
        },
        {
            id: "item-8",
            index: 7,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
            ],
            thumb: "//picsum.photos/id/307/500/700",
            name: "Sintel"
        },
        {
            id: "item-9",
            index: 8,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4"
            ],
            thumb: "//picsum.photos/id/208/500/700",
            name: "Subaru Outback On Street And Dirt"
        },
        {
            id: "item-10",
            index: 9,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4"
            ],
            thumb: "//picsum.photos/id/209/500/700",
            name: "Tears of Steel"
        },
        {
            id: "item-11",
            index: 10,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4"
            ],
            thumb: "//picsum.photos/id/210/500/700",
            name: "Volkswagen GTI Review"
        },
        {
            id: "item-12",
            index: 11,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4"
            ],
            thumb: "//picsum.photos/id/211/500/700",
            name: "We Are Going On Bullrun"
        },
        {
            id: "item-13",
            index: 12,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4"
            ],
            thumb: "//picsum.photos/id/212/500/700",
            name: "What care can you get for a grand?"
        },
        {
            id: "item-14",
            index: 13,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4"
            ],
            thumb: "//picsum.photos/id/213/500/700",
            name: "Big Buck Bunny"
        },
        {
            id: "item-15",
            index: 14,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4"
            ],
            thumb: "//picsum.photos/id/214/500/700",
            name: "Elephant Dream"
        },
        {
            id: "item-16",
            index: 15,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
            ],
            thumb: "//picsum.photos/id/215/500/700",
            name: "For Bigger Blazes"
        },
        {
            id: "item-17",
            index: 16,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerEscapes.mp4"
            ],
            thumb: "//picsum.photos/id/216/500/700",
            name: "For Bigger Escape"
        },
        {
            id: "item-18",
            index: 17,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerFun.mp4"
            ],
            thumb: "//picsum.photos/id/217/500/700",
            name: "For Bigger Fun"
        },
        {
            id: "item-19",
            index: 18,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerJoyrides.mp4"
            ],
            thumb: "//picsum.photos/id/218/500/700",
            name: "For Bigger Joyrides"
        },
        {
            id: "item-20",
            index: 19,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerMeltdowns.mp4"
            ],
            thumb: "//picsum.photos/id/219/500/700",
            name: "For Bigger Meltdowns"
        },
        {
            id: "item-21",
            index: 20,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/Sintel.mp4"
            ],
            thumb: "//picsum.photos/id/220/500/700",
            name: "Sintel"
        },
        {
            id: "item-22",
            index: 21,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnStreetAndDirt.mp4"
            ],
            thumb: "//picsum.photos/id/221/500/700",
            name: "Subaru Outback On Street And Dirt"
        },
        {
            id: "item-23",
            index: 22,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4"
            ],
            thumb: "//picsum.photos/id/222/500/700",
            name: "Tears of Steel"
        },
        {
            id: "item-24",
            index: 23,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4"
            ],
            thumb: "//picsum.photos/id/223/500/700",
            name: "Volkswagen GTI Review"
        },
        {
            id: "item-25",
            index: 24,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4"
            ],
            thumb: "//picsum.photos/id/324/500/700",
            name: "We Are Going On Bullrun"
        },
        {
            id: "item-26",
            index: 25,
            sources: [
                "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WhatCarCanYouGetForAGrand.mp4"
            ],
            thumb: "//picsum.photos/id/225/500/700",
            name: "What care can you get for a grand?"
        }
    ]
};



/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
// IE11 doesn't support classList on SVG elements, so we emulate it with a Set
class $0e5c059fc79abe53$var$ClassList {
    constructor(element){
        this.classes = new Set();
        this.changed = false;
        this.element = element;
        const classList = (element.getAttribute("class") || "").split(/\s+/);
        for (const cls of classList)this.classes.add(cls);
    }
    add(cls) {
        this.classes.add(cls);
        this.changed = true;
    }
    remove(cls) {
        this.classes.delete(cls);
        this.changed = true;
    }
    commit() {
        if (this.changed) {
            let classString = "";
            this.classes.forEach((cls)=>classString += cls + " ");
            this.element.setAttribute("class", classString);
        }
    }
}
/**
 * Stores the ClassInfo object applied to a given AttributePart.
 * Used to unset existing values when a new ClassInfo object is applied.
 */ const $0e5c059fc79abe53$var$previousClassesCache = new WeakMap();
const $0e5c059fc79abe53$export$56cc687933817664 = (0, $3e8bd64d8ced9af7$export$99b43ad1ed32e735)((classInfo)=>(part)=>{
        if (!(part instanceof (0, $9115fb5260f5b78e$export$da9b3ca39c846561)) || part instanceof (0, $9115fb5260f5b78e$export$b78f5e1c476c794e) || part.committer.name !== "class" || part.committer.parts.length > 1) throw new Error("The `classMap` directive must be used in the `class` attribute and must be the only part in the attribute.");
        const { committer: committer } = part;
        const { element: element } = committer;
        let previousClasses = $0e5c059fc79abe53$var$previousClassesCache.get(part);
        if (previousClasses === undefined) {
            // Write static classes once
            // Use setAttribute() because className isn't a string on SVG elements
            element.setAttribute("class", committer.strings.join(" "));
            $0e5c059fc79abe53$var$previousClassesCache.set(part, previousClasses = new Set());
        }
        const classList = element.classList || new $0e5c059fc79abe53$var$ClassList(element);
        // Remove old classes that no longer apply
        // We use forEach() instead of for-of so that re don't require down-level
        // iteration.
        previousClasses.forEach((name)=>{
            if (!(name in classInfo)) {
                classList.remove(name);
                previousClasses.delete(name);
            }
        });
        // Add or remove classes based on their classMap value
        for(const name in classInfo){
            const value = classInfo[name];
            if (value != previousClasses.has(name)) {
                // We explicitly want a loose truthy check of `value` because it seems
                // more convenient that '' and 0 are skipped.
                if (value) {
                    classList.add(name);
                    previousClasses.add(name);
                } else {
                    classList.remove(name);
                    previousClasses.delete(name);
                }
            }
        }
        if (typeof classList.commit === "function") classList.commit();
    });


/**
 * @license
 * Copyright (c) 2018 The Polymer Project Authors. All rights reserved.
 * This code may only be used under the BSD style license found at
 * http://polymer.github.io/LICENSE.txt
 * The complete set of authors may be found at
 * http://polymer.github.io/AUTHORS.txt
 * The complete set of contributors may be found at
 * http://polymer.github.io/CONTRIBUTORS.txt
 * Code distributed by Google as part of the polymer project is also
 * subject to an additional IP rights grant found at
 * http://polymer.github.io/PATENTS.txt
 */ 
/**
 * Stores the StyleInfo object applied to a given AttributePart.
 * Used to unset existing values when a new StyleInfo object is applied.
 */ const $74d80410d825d70d$var$previousStylePropertyCache = new WeakMap();
const $74d80410d825d70d$export$1e5b4ce2fa884e6a = (0, $3e8bd64d8ced9af7$export$99b43ad1ed32e735)((styleInfo)=>(part)=>{
        if (!(part instanceof (0, $9115fb5260f5b78e$export$da9b3ca39c846561)) || part instanceof (0, $9115fb5260f5b78e$export$b78f5e1c476c794e) || part.committer.name !== "style" || part.committer.parts.length > 1) throw new Error("The `styleMap` directive must be used in the style attribute and must be the only part in the attribute.");
        const { committer: committer } = part;
        const { style: style } = committer.element;
        let previousStyleProperties = $74d80410d825d70d$var$previousStylePropertyCache.get(part);
        if (previousStyleProperties === undefined) {
            // Write static styles once
            style.cssText = committer.strings.join(" ");
            $74d80410d825d70d$var$previousStylePropertyCache.set(part, previousStyleProperties = new Set());
        }
        // Remove old properties that no longer exist in styleInfo
        // We use forEach() instead of for-of so that re don't require down-level
        // iteration.
        previousStyleProperties.forEach((name)=>{
            if (!(name in styleInfo)) {
                previousStyleProperties.delete(name);
                if (name.indexOf("-") === -1) // eslint-disable-next-line @typescript-eslint/no-explicit-any
                style[name] = null;
                else style.removeProperty(name);
            }
        });
        // Add or update properties
        for(const name in styleInfo){
            previousStyleProperties.add(name);
            if (name.indexOf("-") === -1) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            style[name] = styleInfo[name];
            else style.setProperty(name, styleInfo[name]);
        }
    });


function $351d24fb6ee29869$export$179403c8c7db692a({ id: id, index: index, name: name, sources: sources, thumb: thumb, style: style = {}, classList: classList = {}, onClick: onClick = null }) {
    return (0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<div
    @click=${onClick}
    class="${(0, $0e5c059fc79abe53$export$56cc687933817664)(classList)}"
    style="${(0, $74d80410d825d70d$export$1e5b4ce2fa884e6a)(style)}"
    data-index="${index}"
    key="${id}"
  >
    <div class="content content--current">
      <div class="image">
        <video muted id="${id}" width="100%" height="100%" poster="${thumb}">
          ${sources.map((source)=>(0, $e5ed8027d647799b$export$c0bb0b647f701bb5)`<source src="${source}" type="video/webm" />`)}
          Sorry, your browser doesn't support embedded videos.
        </video>
      </div>
    </div>

    <div class="steps">
      <div class="progress">
        <div class="current" style="width: 100%"></div>
      </div>
      <div class="progress">
        <div class="current" style="width: 100%"></div>
      </div>
      <div class="progress"><div class="current" style="width: 30%"></div></div>
    </div>

    <div class="content">
      <img class="image" src="${thumb}" />
    </div>
    <div class="content">
      <div class="infos no-scale">
        <div class="rounded">
          <img
            class="thumbnail"
            src="//picsum.photos/100/100?random=${index}"
          />
        </div>

        <p>${name}</p>
      </div>
    </div>
  </div>`;
}


let $35da740d59af89ba$var$delta = 4; // Visible items around the current item
let $35da740d59af89ba$var$scaleValue = 0.45;
let $35da740d59af89ba$var$margin = 2;
let $35da740d59af89ba$var$current = 0;
let $35da740d59af89ba$var$transitionDuration = 600;
let $35da740d59af89ba$var$borderRadius = 0.5;
const $35da740d59af89ba$var$el = document.querySelector(".container");
const $35da740d59af89ba$var$model = document.querySelector(".item--model");
const $35da740d59af89ba$var$transforms = [
    ...new Array($35da740d59af89ba$var$delta * 2 + 1)
].map((_)=>[]);
let $35da740d59af89ba$var$transitionEnd = null;
function $35da740d59af89ba$var$onClick(e) {
    $35da740d59af89ba$var$goto(parseInt(e.currentTarget.dataset.index, 10), $35da740d59af89ba$var$transitionDuration);
}
function $35da740d59af89ba$var$translate(element, index = 0) {
    return (0, $cfbcedb4befb73c9$export$5667f2d3f182f284)((element.offsetWidth - element.offsetWidth * $35da740d59af89ba$var$scaleValue) * Math.max(-1, Math.min(1, index)) / 2 + (element.offsetWidth * $35da740d59af89ba$var$scaleValue + $35da740d59af89ba$var$margin) * index);
}
function $35da740d59af89ba$var$goto(pos, duration = 0) {
    $35da740d59af89ba$var$current = pos;
    const items = (0, $2a9f999bc54a0719$export$4051a07651545597).items.map(({ style: style = {}, classList: classList = {}, ...item }, index)=>{
        const isCurrent = pos === index;
        // console.log("visibleIndex", index + delta - pos, index, pos);
        if ($35da740d59af89ba$var$transforms[index + $35da740d59af89ba$var$delta - pos]) {
            classList = {
                ...classList,
                item: true,
                "item--current": !!isCurrent
            };
            style = {
                ...style,
                transform: (0, $cfbcedb4befb73c9$export$f84e8e69fd4488a5)($35da740d59af89ba$var$transforms[index + $35da740d59af89ba$var$delta - pos]),
                transition: duration > 0 ? `transform ${duration}ms ease, opacity ${duration}ms ease, border-radius ${duration}ms ease` : "none",
                borderRadius: pos === index ? `${$35da740d59af89ba$var$borderRadius}rem` : `${$35da740d59af89ba$var$borderRadius / $35da740d59af89ba$var$scaleValue}rem`
            };
        }
        return {
            ...item,
            classList: classList,
            style: style,
            onClick: $35da740d59af89ba$var$onClick
        };
    }).filter((_, index)=>index >= pos - $35da740d59af89ba$var$delta && index <= pos + $35da740d59af89ba$var$delta);
    (0, $ca64cbbfd570e12d$export$b3890eb0ae9dca99)((0, $e41d1b66de65ecc4$export$76d90c956114f2c2)(items, (item)=>item.id, (0, $351d24fb6ee29869$export$179403c8c7db692a)), $35da740d59af89ba$var$el);
    const videos = $35da740d59af89ba$var$el.querySelectorAll("video");
    [
        ...videos
    ].filter(({ paused: paused })=>!paused).forEach((video)=>video.pause());
    if ($35da740d59af89ba$var$transitionEnd) clearTimeout($35da740d59af89ba$var$transitionEnd);
    $35da740d59af89ba$var$transitionEnd = setTimeout(()=>{
        const currentVideo = [
            ...videos
        ].find((video)=>(0, $2a9f999bc54a0719$export$4051a07651545597).items[$35da740d59af89ba$var$current] && (0, $2a9f999bc54a0719$export$4051a07651545597).items[$35da740d59af89ba$var$current].id === video.id);
        currentVideo.play();
    }, duration);
}
function $35da740d59af89ba$var$recalculateTransforms() {
    if ($35da740d59af89ba$var$el && $35da740d59af89ba$var$model) {
        $35da740d59af89ba$var$el.style.width = `${Math.floor($35da740d59af89ba$var$model.offsetWidth + $35da740d59af89ba$var$margin + ($35da740d59af89ba$var$model.offsetWidth * $35da740d59af89ba$var$scaleValue + $35da740d59af89ba$var$margin) * $35da740d59af89ba$var$delta)}px`;
        $35da740d59af89ba$var$transforms.forEach((_, index)=>{
            const transform = getComputedStyle($35da740d59af89ba$var$model).transform;
            $35da740d59af89ba$var$transforms[index] = [
                (0, $cfbcedb4befb73c9$export$3004f64547af360e)(transform),
                $35da740d59af89ba$var$translate($35da740d59af89ba$var$model, index - $35da740d59af89ba$var$delta),
                (0, $cfbcedb4befb73c9$export$dcdf75081b88279d)(index === $35da740d59af89ba$var$delta ? 1 : $35da740d59af89ba$var$scaleValue)
            ].reduce((0, $cfbcedb4befb73c9$export$2060d2db72cce88f));
        });
    }
}
function $35da740d59af89ba$var$init() {
    $35da740d59af89ba$var$recalculateTransforms();
    $35da740d59af89ba$var$goto($35da740d59af89ba$var$current, 0);
}
$35da740d59af89ba$var$init();
window.addEventListener("resize", (e)=>$35da740d59af89ba$var$init(e));


//# sourceMappingURL=index.b37d6b3d.js.map
